// Global Instructions Rule Applied!
//
// Configuration → Pipeline Budget admin model: the GL accounts the Deal
// Pipeline → Budget tab lists under Cash (cfg.deal_pipeline_budget_accounts,
// owner 2026-11-03).
//
// Shape mirrors one row of public.view__deal_pipeline_budget_accounts_admin
// and its gl_account_options: the accounts a row can point at.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const PipelineBudgetAccountAdminRowSchema = z
  .object({
    deal_pipeline_budget_accounts__id: z.string(),
    deal_pipeline_budget_accounts__gl_account_id: z.string(),
    // NULL = the Budget tab shows the GL account's own name
    deal_pipeline_budget_accounts__label: z.string().nullable(),
    deal_pipeline_budget_accounts__display_order: z.number().int(),
    deal_pipeline_budget_accounts__date_modified: z.string().nullable(),
    acc_gl_accounts__account_code: z.string().nullable(),
    acc_gl_accounts__account_name: z.string(),
    acc_account_types__label: z.string().nullable(),
    // audit.resolve_user_name: System for a NULL modified_by
    prog__modified_by_name: z.string()
  })
  .strict()

export type PipelineBudgetAccountAdminRow = z.infer<typeof PipelineBudgetAccountAdminRowSchema>

/** A live GL account with a code: value = cfg.acc_gl_accounts.id, label =
 *  "code · name". */
export const PipelineBudgetGlAccountOptionSchema = z
  .object({
    value: z.string(),
    label: z.string()
  })
  .strict()

export type PipelineBudgetGlAccountOption = z.infer<typeof PipelineBudgetGlAccountOptionSchema>

export const PipelineBudgetAccountsAdminSchema = z.object({
  data: z.array(PipelineBudgetAccountAdminRowSchema),
  gl_account_options: z.array(PipelineBudgetGlAccountOptionSchema)
})

export type PipelineBudgetAccountsAdmin = z.infer<typeof PipelineBudgetAccountsAdminSchema>

export const validatePipelineBudgetAccountsAdmin = (data: unknown): PipelineBudgetAccountsAdmin =>
  validateWithZodSchema(PipelineBudgetAccountsAdminSchema, data, 'pipeline budget accounts')
